module.exports = __webpack_public_path__ + "img/sa_old.c3d67d68.png";